/* src/features/5DD/historyService.js */
import { db } from '../../apiClient';

export const historyService = {

  /**
   * Get List of Past Courses (History Index)
   */
  getHistoryIndex: async (userId) => {
    const data = await db.courses.history();
    return data || [];
  },

  /**
   * Get Meals for a Specific Range
   */
  getCourseMeals: async (userId, startDate, endDate) => {
    const data = await db.meals.list({ start_date: startDate, end_date: endDate });
    return data || [];
  },

  /**
   * Get Daily Habits for a Specific Range
   */
  getDailyHabits: async (userId, startDate, endDate) => {
    const start = startDate.split('T')[0];
    const end = endDate.split('T')[0];
    try {
      const data = await db.habits.list({ start_date: start, end_date: end });
      return data || [];
    } catch (e) {
      console.error("Error fetching daily habits:", e);
      return [];
    }
  }
};
